<p-sidebar [(visible)]="visivel"
           position="right"
           [style]="{ width: '38rem' }"
           [blockScroll]="true"
           styleClass="shadow-lg"
           (onHide)="onSidebarHide()">

  <!-- Wave Header -->
  <ng-template pTemplate="header">
    <div class="sidebar-wave-header sidebar-wave-header--info">
      <div class="sidebar-wave-header-content">
        <div class="sidebar-wave-icon-container">
          <i class="pi pi-box" aria-hidden="true"></i>
        </div>
        <div class="sidebar-wave-header-text">
          <h2>{{ tituloSidebar }}</h2>
          <p>{{ descricaoSidebar }}</p>
        </div>
      </div>
      <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>
  </ng-template>

  <p-toast position="top-right"></p-toast>

  <div class="p-fluid pt-3">
    <!-- Imagem do Produto -->
    <div class="surface-card p-4 border-round-xl border-1 surface-border mb-3 shadow-sm">
      <div class="flex flex-column align-items-center">
        <div *ngIf="imagePreviewUrl" class="relative w-full border-round-xl overflow-hidden shadow-2 surface-100 mb-3 border-1 surface-border" style="max-height: 180px;">
          <img [src]="imagePreviewUrl" class="w-full h-full" style="object-fit: cover; display: block;" />
          <div class="absolute top-0 right-0 p-2">
            <button pButton type="button" icon="pi pi-trash"
                    class="p-button-danger p-button-rounded p-button-sm p-button-text"
                    (click)="onClearImage()"></button>
          </div>
        </div>
        <p-fileUpload name="produtoImg" [multiple]="false" accept="image/*"
                      [maxFileSize]="5000000" [showUploadButton]="false" [showCancelButton]="false"
                      chooseIcon="pi pi-camera"
                      styleClass="p-button-outlined w-full" (onSelect)="onSelectImage($event)">
        </p-fileUpload>
      </div>
    </div>

    <!-- Nome -->
    <div class="field">
      <label class="font-bold text-sm text-700">{{ texts.nome }}</label>
      <input pInputText [(ngModel)]="form.nome" class="w-full mt-1" />
    </div>

    <!-- Descricao -->
    <div class="field">
      <label class="font-bold text-sm text-700">{{ texts.descricao }}</label>
      <textarea pInputTextarea [(ngModel)]="form.descricao" [rows]="3" class="w-full mt-1"></textarea>
    </div>

    <!-- Secao Preco -->
    <div class="surface-card p-4 border-round-xl border-1 surface-border mb-3 shadow-sm">
      <div class="flex align-items-center gap-2 mb-3">
        <i class="pi pi-dollar text-primary"></i>
        <span class="text-900 font-bold uppercase text-xs">{{ texts.preco }}</span>
      </div>

      <!-- Toggle Simples / Variantes -->
      <p-selectButton [options]="modoPrecoOptions" [(ngModel)]="form.tipoPreco"
                      optionLabel="label" optionValue="value"
                      styleClass="mb-3">
      </p-selectButton>

      <!-- Modo Simples -->
      <div *ngIf="form.tipoPreco === 'SIMPLES'" class="flex flex-column gap-3">
        <div class="field m-0">
          <label class="font-bold text-sm text-700">{{ texts.preco_original }}</label>
          <p-inputNumber [(ngModel)]="form.preco" mode="decimal"
                         [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                         [minFractionDigits]="0" [maxFractionDigits]="0"
                         styleClass="w-full mt-1"
                         inputStyleClass="border-round-lg">
          </p-inputNumber>
        </div>
        <div class="field m-0">
          <label class="font-bold text-sm text-700">{{ texts.preco_promocional }}</label>
          <p-inputNumber [(ngModel)]="form.precoPromocional" mode="decimal"
                         [prefix]="moedaSimbolo + ' '" [locale]="moedaLocal"
                         [minFractionDigits]="0" [maxFractionDigits]="0"
                         styleClass="w-full mt-1"
                         inputStyleClass="border-round-lg">
          </p-inputNumber>
        </div>
      </div>

      <!-- Modo Variantes (novo sub-componente) -->
      <div *ngIf="form.tipoPreco === 'VARIANTES'">
        <app-variante-secao
          [variantes]="variantes"
          [produtoId]="produto?.id || 0"
          [moedaSimbolo]="moedaSimbolo"
          [moedaLocal]="moedaLocal"
          [loading]="loadingVariantes"
          (criarVariante)="onCriarVariante($event)"
          (atualizarVariante)="onAtualizarVariante($event)"
          (removerVariante)="onRemoverVariante($event)"
          (reordenarVariantes)="onReordenarVariantes($event)"
          (toggleAtivoVariante)="onToggleAtivoVariante($event)">
        </app-variante-secao>
      </div>
    </div>

    <!-- Controle de Estoque -->
    <div class="surface-card p-4 border-round-xl border-1 surface-border mb-3 shadow-sm">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center gap-2">
          <span class="font-bold text-sm text-700">{{ texts.controle_estoque }}</span>
          <i class="pi pi-info-circle text-400" [pTooltip]="texts.info_estoque"></i>
        </div>
        <p-inputSwitch [(ngModel)]="form.controleEstoque"></p-inputSwitch>
      </div>
    </div>

    <!-- Modificadores (novo sub-componente) -->
    <app-modificador-secao
      [gruposAssociados]="gruposAssociados"
      [produtoId]="produto?.id || 0"
      [loading]="loadingModificadores"
      (desassociarGrupo)="onDesassociarGrupo($event)"
      (reordenarGrupos)="onReordenarGrupos($event)"
      (abrirGestaoModal)="modalModificadorVisivel = true"
      (grupoAtualizado)="onGrupoAtualizado()">
    </app-modificador-secao>

    <!-- Modal de Gestao de Modificadores -->
    <app-modificador-gestao-modal
      [(visivel)]="modalModificadorVisivel"
      [produtoId]="produto?.id || 0"
      [gruposAssociados]="gruposAssociados"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      (grupoAssociado)="onGrupoAssociado($event)"
      (grupoDesassociado)="onGrupoDesassociadoFromModal($event)"
      (grupoAtualizado)="onGrupoAtualizado()">
    </app-modificador-gestao-modal>

    <!-- Visibilidade -->
    <div class="surface-card p-4 border-round-xl border-1 surface-border mb-3 shadow-sm">
      <div class="flex align-items-center justify-content-between">
        <span class="font-bold text-sm text-700">{{ texts.visivel_cardapio }}</span>
        <p-inputSwitch [(ngModel)]="form.visivel"></p-inputSwitch>
      </div>
    </div>

    <!-- Botoes de acao -->
    <div class="flex justify-content-end gap-3 mt-4 pt-4 border-top-1 surface-border">
      <button pButton [label]="texts.cancelar" (click)="onCancelar()"
              severity="secondary" class="p-button-text font-bold"></button>
      <button pButton [label]="texts.salvar" icon="pi pi-check" type="button"
              [disabled]="!form.nome.trim() || salvando"
              [loading]="salvando"
              (click)="onSubmit()"
              class="btn-primary"></button>
    </div>
  </div>
</p-sidebar>
